import React, {
  useMemo,
} from "react";
import { Box, Typography } from "@mui/material";

const Label = ({
  labelPosition,
  displayName,
  subtitle,
  alignment = "auto", // "auto" flips left/right based on x
  offsetLeft = 0,
}) => {
  // Decide left vs right if in "auto" mode
  const effectiveAlignment = useMemo(() => {
    if (alignment === "auto") {
      const w = typeof window !== "undefined" ? window.innerWidth : 0;
      return labelPosition.x < w / 3 ? "right" : "left";
    }
    return alignment;
  }, [alignment, labelPosition.x]);

  // Map alignment to CSS translate
  const transform = useMemo(() => {
    switch (effectiveAlignment) {
      case "left":
        return "translate(-105%, -50%)";
      case "right":
        return "translate(5%, -50%)";
      case "top":
        return "translate(-50%, -105%)";
      case "bottom":
        return "translate(-50%, 5%)";
      default:
        return "translate(-50%, -50%)";
    }
  }, [effectiveAlignment]);

  return (
    <Box
      sx={{
        position: "absolute",
        top: labelPosition.y,
        left: labelPosition.x + offsetLeft,
        transform,
        background: "var(--label-background)",
        color: "var(--label-text, #083033)",
        padding: "8px 16px",
        borderRadius: "var(--radius-md, 10px)",
        border: "var(--label-border, 1px solid rgba(210, 255, 249, 0.36))",
        pointerEvents: "none",
        overflow: "hidden",
        display: "inline-block",
        textAlign: "center",
        whiteSpace: "nowrap",
        boxShadow:
          "var(--label-shadow, 0 10px 26px rgba(0, 0, 0, 0.22), inset 0 1px 0 rgba(255, 255, 255, 0.2))",
        backdropFilter:
          "blur(var(--label-blur, 12px)) saturate(var(--label-saturate, 135%))",
        WebkitBackdropFilter:
          "blur(var(--label-blur, 12px)) saturate(var(--label-saturate, 135%))",
      }}
    >
      <Typography variant="h5">{displayName}</Typography>
      {subtitle && (
        <Typography
          variant="caption"
          component="div"
          sx={{ color: "var(--label-subtitle, rgba(8, 48, 51, 0.8))", letterSpacing: "0.05em" }}
        >
          <em>{subtitle}</em>
        </Typography>
      )}
    </Box>
  );
};

export default Label;
